module.exports = __webpack_public_path__ + "static/Camping1-b0095ddcd6aaf1f40fdaa450d29c350e.jpg";